var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"outlined":"","hide-details":"","dense":""},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}},'v-select',{ items: _vm.items, disabled: _vm.disabled },false))
}
var staticRenderFns = []

export { render, staticRenderFns }